import * as React from 'react';
import { __ } from '../helpers/TranslationService';
import { changeRouteSuccess } from './routerActions';
import { defaultSeo } from '../reducers/pageData';

import loadable from '@loadable/component';

export const errorPageRouteAction = context => {
    const { path, params, baseUrl, action } = context;
    const seo = defaultSeo;
    seo.titleOg = __('Error', 'dreamlines');
    context.store.dispatch(
        changeRouteSuccess({
            path,
            params,
            baseUrl,
            action,
            seo: seo,
        }),
    );

    const ErrorPage = loadable(() => import('../pages/Error/ErrorPage'));
    return {
        component: <ErrorPage />,
        context,
    };
};
